import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FilterModule, TaskService } from '@starfish-access/core';
import { StarfishCommonModule } from '../../shared/common.module';
import { TaskListComponent } from './tasklist.component';
import { TaskListFacade } from './tasklist.facade.service';
import { routes } from './tasklist.routing';

@NgModule({
  imports: [
    CommonModule,
    StarfishCommonModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    FlexLayoutModule,
    FilterModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  declarations: [TaskListComponent],
  exports: [RouterModule],
  providers: [TaskService, TaskListFacade],
})
export class TaskListModule {}
